import { useEffect, useCallback } from "react";
import PropTypes from 'prop-types';
import { notification } from 'antd';

const NotificationComponent = ({ showNotification, onCloseNotification, title, message }) => {

  const [api, contextHolder] = notification.useNotification();

  const openNotification = useCallback(
    pauseOnHover => () => {
    api.open({
      title: title,
      description: message,
      showProgress: true,
      pauseOnHover,
      onClose: onCloseNotification,
      duration: 6
    });
  }, [api, onCloseNotification]
  )

  useEffect(() => {
    if (showNotification) {
      openNotification(true)();
    }
  }, [showNotification, openNotification]);

  return (contextHolder);
};

NotificationComponent.propTypes = {
  showNotification: PropTypes.bool,
  onCloseNotification: PropTypes.func
};

export default NotificationComponent;
